const mainProductCarouselElement = document.querySelectorAll('.main-product-carousel')
const mobileScreen = (window.innerWidth < 770) ? true : false;

if (mobileScreen) {
  mainProductCarouselElement.forEach(elem => {
    new Flickity( elem, {
      fullscreen: true,
      prevNextButtons: false,
      pageDots: true
    });
  })
}

// const mainProductnewCarouselElement = document.querySelectorAll('.color_var_slide')

//  mainProductnewCarouselElement.forEach(elem => {
//     new Flickity( elem, {
//       fullscreen: true,
//       prevNextButtons: true,
//       pageDots: true,
//       draggable: false,
//       responsive: [
//       {
//         breakpoint: 989,
//         settings: {
//            draggable: true
          
//         }
//       }
//     ]
//     });
//   })

var width = $(window).width();
const loader = document.querySelector('.bg-view');
     if(width > 988){
        myInterval = setInterval(function(){
            const mainProductnewCarouselElement = document.querySelectorAll('.color_var_slide');
            console.log("mainProductnewCarouselElement");
            console.log(mainProductnewCarouselElement.length);
           
            if(mainProductnewCarouselElement.length >= 1){
              clearInterval(myInterval);
              console.log("Hello");              
              if(loader){
                 loader.style.display = 'none';
              }
              mainProductnewCarouselElement.forEach(elem => {
                const flickityInstance = new Flickity(elem, {
                      fullscreen: true,
                      prevNextButtons: true,
                      pageDots: true,
                      draggable: false,
                      responsive: [
                          {
                              breakpoint: 989,
                              settings: {
                                  draggable: true
                              }
                          }
                      ]
                  });
                
                  const slideCount = flickityInstance.slides.length;
                  console.log(slideCount);
                  if(slideCount === 1) {
                      const dotsContainer = elem.querySelector('.flickity-page-dots');
                      const previousbuttonContainer = elem.querySelector('.flickity-button.previous');
                      const nextbuttonContainer = elem.querySelector('.flickity-button.next');
                        
                      console.log("SLIDER DOT");
                      dotsContainer.parentNode.removeChild(dotsContainer);
                      previousbuttonContainer.parentNode.removeChild(previousbuttonContainer);
                      nextbuttonContainer.parentNode.removeChild(nextbuttonContainer);
                  }
                
              });
            }
          }, 1500);
          //  setTimeout(() => {
          //    const mainProductnewCarouselElement = document.querySelectorAll('.color_var_slide');
    
          //     mainProductnewCarouselElement.forEach(elem => {
          //       const flickityInstance = new Flickity(elem, {
          //             fullscreen: true,
          //             prevNextButtons: true,
          //             pageDots: true,
          //             draggable: false,
          //             responsive: [
          //                 {
          //                     breakpoint: 989,
          //                     settings: {
          //                         draggable: true
          //                     }
          //                 }
          //             ]
          //         });
                
          //         const slideCount = flickityInstance.slides.length;
          //         console.log(slideCount);
          //         if(slideCount === 1) {
          //             const dotsContainer = elem.querySelector('.flickity-page-dots');
          //             const previousbuttonContainer = elem.querySelector('.flickity-button.previous');
          //             const nextbuttonContainer = elem.querySelector('.flickity-button.next');
                        
          //             console.log("SLIDER DOT");
          //             dotsContainer.parentNode.removeChild(dotsContainer);
          //             previousbuttonContainer.parentNode.removeChild(previousbuttonContainer);
          //             nextbuttonContainer.parentNode.removeChild(nextbuttonContainer);
          //         }
                
          //     });
          // }, 900);
      }else{
          myInterval = setInterval(function(){
             const mainProductnewCarouselElement = document.querySelectorAll('.color_var_slide')
              if(mainProductnewCarouselElement.length >= 1){
                  clearInterval(myInterval);
                  if(loader){
                       loader.style.display = 'none';
                  }
                   mainProductnewCarouselElement.forEach(elem => {
                       const flickityInstance = new Flickity( elem, {
                          fullscreen: true,
                          prevNextButtons: true,
                          pageDots: true,
                          draggable: true,
                          responsive: [
                          {
                            breakpoint: 989,
                            settings: {
                               draggable: true
                              
                            }
                          }
                        ]
                        });
                
                       const slideCount = flickityInstance.slides.length;
                        console.log(slideCount);
                        if(slideCount === 1) {
                        const dotsContainer = elem.querySelector('.flickity-page-dots');
                        const previousbuttonContainer = elem.querySelector('.flickity-button.previous');
                        const nextbuttonContainer = elem.querySelector('.flickity-button.next');
                          
                        console.log("SLIDER DOT");
                        dotsContainer.parentNode.removeChild(dotsContainer);
                        previousbuttonContainer.parentNode.removeChild(previousbuttonContainer);
                        nextbuttonContainer.parentNode.removeChild(nextbuttonContainer);
                    }
                   })
              }
          }, 1500);
      }